import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AccountAssessment } from '../../models/AssessmentModel';
import { Account } from '../../models/AccountModel';

@Component({
  selector: 'cw-ci-assessment-report',
  templateUrl: './assessment-report.component.html',
  styleUrls: ['./assessment-report.component.scss']
})
export class AssessmentReportComponent implements OnInit {
  selectedNistFunction: string;
  selectedNistSubCategory: string;
  questionDetailSelection: { nistFunction: undefined, nistSubCategory: undefined };

  @Input() account: Account;
  @Input() accountAssessment: AccountAssessment;
  @Output() stateChange: EventEmitter<any> = new EventEmitter(true);

  constructor() { }

  ngOnInit() { }

  selectNistFunction(event) {
    this.selectedNistFunction = event.selectedNistFunction;
    this.questionDetailSelection = undefined;
  }

  selectNistSubCategory(event) {
    this.questionDetailSelection = {
      nistFunction: event.selectedNistFunction,
      nistSubCategory: event.selectedNistSubCategory
    };
  }
}
